import React from 'react';
import { useTranslation } from 'react-i18next';
import './QuestionModal.css';

const QuestionStepper = ({
    currentStep = 1,
    onStepChange = () => {},
    isAiMode = false,
    onExitAiMode = () => {},
    typeId = 1
}) => {
    const { t } = useTranslation('common');

    const getDynamicSteps = () => {
        if (typeId === 11) {
            return [
                {
                    id: 1,
                    title: t('AILessonChat.stepMainInfo') || 'معلومات السؤال ورسالة الدرس',
                    icon: 'fal fa-file-alt'
                },
                {
                    id: 2,
                    title: t('AILessonChat.stepSkills') || 'المهارات والأبعاد',
                    icon: 'fal fa-sitemap'
                }
            ];
        }

        const isCategoryType = (typeId === 10 || typeId === 13 || typeId === 32);

        let designerTitle = t('AILessonChat.stepAnswers') || 'تصميم الخيارات والإجابات';
        let designerIcon = 'fal fa-list-check';

        if (typeId === 2) {
            designerTitle = t('AILessonChat.stepOrderDesigner') || 'تصميم الترتيب والتسلسل';
            designerIcon = 'fal fa-sort-amount-down';
        } else if (typeId === 3 || typeId === 4 || typeId === 5 || typeId === 6 || typeId === 14) {
            designerTitle = t('AILessonChat.stepFillsDesigner') || 'تصميم الفراغات والنصوص';
            designerIcon = 'fal fa-edit';
        } else if (typeId === 9) {
            designerTitle = t('AILessonChat.stepMatchesDesigner') || 'تصميم التوصيل والمطابقة';
            designerIcon = 'fal fa-link';
        } else if (typeId === 10 || typeId === 13) {
            designerTitle = t('AILessonChat.stepClassificationDesigner') || 'تصميم أقسام التصنيف';
            designerIcon = 'fal fa-tags';
        } else if (typeId >= 15 && typeId <= 31) {
            designerTitle = t('AILessonChat.stepGamesDesigner') || 'مصمم وسائط وإعدادات اللعبة';
            designerIcon = 'fal fa-gamepad';
        }

        if (isCategoryType) {
            return [
                {
                    id: 1,
                    title: t('AILessonChat.stepMainInfo') || 'معلومات السؤال ورسالة الدرس',
                    icon: 'fal fa-file-alt'
                },
                {
                    id: 2,
                    title: t('AILessonChat.stepSkills') || 'المهارات والأبعاد',
                    icon: 'fal fa-sitemap'
                },
                {
                    id: 3,
                    title: t('AILessonChat.stepCategories') || 'تصميم الأقسام والمجموعات',
                    icon: 'fal fa-layer-group'
                },
                {
                    id: 4,
                    title: designerTitle,
                    icon: designerIcon
                }
            ];
        }

        return [
            {
                id: 1,
                title: t('AILessonChat.stepMainInfo') || 'معلومات السؤال ورسالة الدرس',
                icon: 'fal fa-file-alt'
            },
            {
                id: 2,
                title: t('AILessonChat.stepSkills') || 'المهارات والأبعاد',
                icon: 'fal fa-sitemap'
            },
            {
                id: 3,
                title: designerTitle,
                icon: designerIcon
            }
        ];
    };

    const steps = getDynamicSteps();

    if (isAiMode) {
        return (
            <div className="question-stepper-container bg-light">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                        <i className="fal fa-sparkles text-primary font-weight-bold" style={{ fontSize: '1.2rem' }}></i>
                        <span className="font-weight-bold text-primary" style={{ fontSize: '0.95rem' }}>
                            {t('AILessonChat.aiPaneTitle') || 'شات صياغة وتنسيق نص الدرس بالذكاء الاصطناعي ✨'}
                        </span>
                    </div>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary rounded-pill d-inline-flex align-items-center gap-1 btn-auto"
                        onClick={onExitAiMode}
                    >
                        <i className="fal fa-arrow-right ml-1"></i>
                        <span>{t('AILessonChat.backToForm') || 'العودة لخطوات السؤال'}</span>
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="question-stepper-container">
            <div className="question-stepper">
                {steps.map((step, index) => {
                    const isActive = currentStep === step.id;
                    const isCompleted = currentStep > step.id;

                    return (
                        <React.Fragment key={step.id}>
                            <div
                                className={`stepper-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
                                onClick={() => onStepChange(step.id)}
                                title={step.title}
                            >
                                <div className="stepper-badge">
                                    {isCompleted ? (
                                        <i className="far fa-check"></i>
                                    ) : (
                                        step.id
                                    )}
                                </div>
                                <span className="stepper-label">
                                    <i className={`${step.icon} ml-1`}></i>
                                    {step.title}
                                </span>
                            </div>

                            {index < steps.length - 1 && (
                                <div className={`stepper-line ${currentStep > step.id ? 'active' : ''}`}></div>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default QuestionStepper;
